import { FC } from 'react';
import { MenuItemIcon } from '../../../components';
import { HomeOutlined, Home } from '@mui/icons-material';

export const IconStatsSidebar: FC<MenuItemIcon> = ({ active }) =>
  active ? <Home color="primary" /> : <HomeOutlined color="action" />;
